import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { usuario } from '../../Redux/legajo';
import TokenContext from '../../context/TokenContext';
import { UserAuth } from '../../context/AuthContext';

const useUsuario = () => {
    const dispatch = useDispatch();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();
    const usuarioSelector = useSelector((store) => store.legajo.usuarioAutor);
    const [usuarioAutor, setUsuarioAutor] = useState(null);

    useEffect(() => {
        if (token && empleado) {
            dispatch(usuario(token, empleado.usuarioPortalRh));
        }
    }, [token, empleado]);


    useEffect(() => {

        if (usuarioSelector.length > 0) {
            const newArray = usuarioSelector.map((element) => ({
            id: element.systemuserid,
            internalemailaddress: element.internalemailaddress,
            }))
            setUsuarioAutor(newArray[0])
        }
    }, [usuarioSelector])

    return { usuarioAutor }
}

export default useUsuario